import { inject } from "inversify-props";
import { ELEMENT_POSITION, EVENT_NAME, EVENT_TYPE, EventAttributes, Product, MparticleClient, TrackElementObserverEvent, CONTENT_TYPE, CONTENT_PROVIDER } from "@cash-rewards/mparticlejs";
import {ConfigService} from './config/ConfigService';
import { StickyBannerData } from "./RMDataService";
/*
 *  The integration of mParticle SDK
 *  This is a singleton service.
 */
export class MparticleService {
    private _mParticleClient: MparticleClient;
    private _trackEvent : TrackElementObserverEvent;

    @inject("ConfigService") configService: ConfigService;

    public init() {
      if (
          typeof window !== 'undefined' &&
          !this._mParticleClient
      ) {
          this._mParticleClient = new MparticleClient();
          this._mParticleClient.init({
          env: this.configService.getConfig('Environment'),
          appName: 'cr-global-footer',
          version: '1.0.0',
          mParticleApiKey: this.configService.getConfig('mParticleApiKey')
          });
        }
  }

  public getImpressionProductEventdata(
    element_id: string,
    element_position: ELEMENT_POSITION,
    ad_size_id: number,
    content_descriptor: string,
    parent_element: string,
    ad: StickyBannerData
  ): Product[] {
    return [
      {
        id: element_id,
        name: element_id,
        custom_attributes: {
          advertiser_name: ad.advertiserName,
          advertiser_id: ad.advertiserId,
          advertising_priority_weight: ad.priorityWeight,
          campaign_id: ad.campaignId,
          flight_id: ad.flightId,
          ad_id: ad.id,
          ad_size_id,
          content_type: CONTENT_TYPE.ads,
          content_provider: CONTENT_PROVIDER.kevel,
          content_friendly_name: ad.title,
          element_position,
          element_id,
          element_destination_page_location: ad.rawClickUrl,
          element_text: ad.text,
          content_call_to_action: ad.cta,
          content_descriptor,
          parent_element,
        },
      },
    ];
  }

  public trackImpression(adElement: HTMLElement | null, element_id: string, ad_size: number, content_descriptor: string, stickyBannerData: StickyBannerData) {    
    if(adElement) {
    const products = this.getImpressionProductEventdata(element_id, ELEMENT_POSITION.footer, ad_size, content_descriptor, 'footer', stickyBannerData);

    this._mParticleClient.trackEvent(EVENT_NAME.impression_ad_unit_render, EVENT_TYPE.Search,  this._mParticleClient.getBaseEventAttributes(EVENT_NAME.impression_ad_unit_render), products);

    this._trackEvent = this._mParticleClient.trackImpressionWhenElementInView(
        adElement,
        EVENT_NAME.impression_ad_unit_viewed,
        EVENT_TYPE.Search,
        this._mParticleClient.getBaseEventAttributes(EVENT_NAME.impression_ad_unit_viewed),
        products,
        true
      );
    }
  }

  public trackEvent(eventName: EVENT_NAME, eventType: EVENT_TYPE = EVENT_TYPE.Other, overrightEventAttributes: EventAttributes = {}) {
    const eventAttributes = this._mParticleClient.getBaseEventAttributes(eventName, overrightEventAttributes);

    return this._mParticleClient.trackEvent(eventName, eventType, eventAttributes);
  }

  public getMpClickEventData(
    element_id: string,
    element_position: ELEMENT_POSITION,
    ad_size_id: number,
    ad: StickyBannerData
  ): EventAttributes {
    return {
      element_id,
      element_position,
      ad_size_id,
      advertiser_name: ad.advertiserName,
      advertiser_id: ad.advertiserId,
      advertising_priority_weight: ad.priorityWeight,
      content_call_to_action: ad.cta,
      campaign_id: ad.campaignId,
      flight_id: ad.flightId,
      ad_id: ad.id,
      element_destination_page_location: ad.rawClickUrl,
      content_type: CONTENT_TYPE.ads,
      content_friendly_name: ad.title,
      content_provider: CONTENT_PROVIDER.kevel,
      element_text: ad.text,
    };
  }

  public disconnect() {
    if (this._trackEvent) {
      this._trackEvent.disconnect();
    }
  }
}